import { apiClient } from '@/sdk/shared/apiClient';
import type {
  ClientTransactionsResponse,
  ClientTransactionsAPIResponse,
  FetchTransactionsParams,
  ClientTransactionsStats,
  ClientTransactionsStatsAPIResponse,
} from './types';

export const clientTransactionsApi = {
  getClientTransactions: async (
    tenantSlug: string,
    params: FetchTransactionsParams = {}
  ): Promise<ClientTransactionsResponse> => {
    const query = new URLSearchParams();
    query.append('tenantSlug', tenantSlug);

    if (params.limit !== undefined) query.append('limit', params.limit.toString());
    if (params.offset !== undefined) query.append('offset', params.offset.toString());
    if (params.type) query.append('type', params.type);
    if (params.status) query.append('status', params.status);
    if (params.currency) query.append('currency', params.currency);
    if (params.method) query.append('method', params.method);
    if (params.search) query.append('search', params.search);
    if (params.startDate) query.append('startDate', params.startDate);
    if (params.endDate) query.append('endDate', params.endDate);
    if (params.sortBy) query.append('sortBy', params.sortBy);
    if (params.sortOrder) query.append('sortOrder', params.sortOrder);

    const response = await apiClient.get<ClientTransactionsAPIResponse>(
      `/client/transactions?${query.toString()}`
    );
    return response.data;
  },

  getClientTransactionsStats: async (
    tenantSlug: string
  ): Promise<ClientTransactionsStats> => {
    const response = await apiClient.get<ClientTransactionsStatsAPIResponse>(
      `/client/transactions/stats?tenantSlug=${tenantSlug}`
    );
    return response.data;
  },
};

export default clientTransactionsApi;
